var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E7454C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5339 42.8696H24.4661C21.9247 42.874 19.7032 41.1563 19.0678 38.6957L16 25.2174L20.3061 28.3478C21.5165 29.233 23.0449 29.5648 24.5134 29.2613C25.9819 28.9578 27.2535 28.0472 28.0139 26.7548L32 20L35.9791 26.7687C36.7418 28.061 38.0158 28.9701 39.4859 29.2711C40.956 29.572 42.4848 29.2366 43.6939 28.3478L48 25.2174L44.9322 38.6957C44.2968 41.1563 42.0753 42.874 39.5339 42.8696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5339 42.8696H24.4661C21.9247 42.874 19.7032 41.1563 19.0678 38.6957L16 25.2174L20.3061 28.3478C21.5165 29.233 23.0449 29.5648 24.5134 29.2613C25.9819 28.9578 27.2535 28.0472 28.0139 26.7548L32 20L35.9791 26.7687C36.7418 28.061 38.0158 28.9701 39.4859 29.2711C40.956 29.572 42.4848 29.2366 43.6939 28.3478L48 25.2174L44.9322 38.6957C44.2968 41.1563 42.0753 42.874 39.5339 42.8696Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.3b809ea005fad809e2447c5b8308c2e5.svg";
export { ForwardRef as ReactComponent };